<template>
  <CockpitDialog class="cameraPicture" title="监控画面" @close="close">
    <YSPlayer
      class="w-full h-full"
      :code="deviceCode"
      :showControlPanel="true"
      :pIid="plid"
    ></YSPlayer>
    <!-- <div class="cameraBox w-full flex justify-between">
      <video src="" class="h-full w-7/10 bg-[#fff]"></video>
      <div class="h-full w-3/10 toolBox flex flex-col justify-around items-center">
        <div>
          <span class="mr-20px">云台速</span
          ><span class="text-[#FFFFFFCC] bg-[#B0D4FE19] display-block pl-5px pr-5px cursor-pointer"
            >2X</span
          >
        </div>
        <div class="relative direction min-w-158px min-h-158px">
          <img
            class="absolute top-10px cursor-pointer left-61px"
            src="../../../../assets/images/smartSecurity/up.png"
            alt=""
          />
          <img
            class="absolute right-10px cursor-pointer top-61px"
            src="../../../../assets/images/smartSecurity/right.png"
            alt=""
          />
          <img
            class="absolute bottom-10px cursor-pointer left-61px"
            src="../../../../assets/images/smartSecurity/down.png"
            alt=""
          />
          <img
            class="absolute left-10px cursor-pointer top-61px"
            src="../../../../assets/images/smartSecurity/left.png"
            alt=""
          />
        </div>
        <div class="flex">
          <span class="mr-20px">云台变速调</span>
          <span
            class=" bg-[#B0D4FE19] display-block w-52px h-40px flex justify-center items-center mr-5px"
          >
            <img
              class="cursor-pointer"
              src="../../../../assets/images/smartSecurity/放大.png"
              alt=""
            />
          </span>
          <span
            class=" bg-[#B0D4FE19] display-block w-52px h-40px flex justify-center items-center"
          >
            <img
              class="cursor-pointer"
              src="../../../../assets/images/smartSecurity/缩小.png"
              alt=""
            />
          </span>
        </div>
      </div>
    </div> -->
  </CockpitDialog>
</template>

<script>
import YSPlayer from '../video/YSPlayer/YSPlayerControl'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  name: 'cameraPicture',
  props: {
    deviceCode: {
      type: String,
      default: '',
    },
    plid: {
      type: String,
      default: '',
    },
  },
  components: {
    CockpitDialog,
    YSPlayer,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('refresh', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.cameraPicture {
  left: 520px;
  top: 200px;
}
.cameraBox {
  height: calc(100% - 50px);
  .toolBox {
    color: #ffffff99;
    font-family: Microsoft YaHei UI;
    font-weight: regular;
    font-size: 20px;
    line-height: normal;
    letter-spacing: 0px;
    text-align: left;
    .direction {
      border-radius: 50%;
      border: 1.93px solid #d9d9d94c;
    }
  }
}
</style>
